export default __webpack_public_path__ + "static/media/latest-news-img29.b815123c.jpg";